import Spinner from '../Icons/Spinner.js';

const LoadingScreen = () => (
    <div className="flex items-center justify-center h-full">
        <Spinner />
    </div>
);

export default LoadingScreen;
